import React from 'react';
import * as motion from 'motion/react-m';
import { useMobileAnimation } from '../hooks/useMobileAnimation';

/**
 * MotionDiv component that wraps motion.div.
 *
 */
const MotionDiv = ({
  children,
  initial,
  animate,
  exit,
  transition,
  ...props
}: React.ComponentProps<typeof motion.div>) => {
  const animationProps = useMobileAnimation({
    initial,
    animate,
    exit,
    transition,
  });

  return (
    <motion.div {...animationProps} {...props}>
      {children}
    </motion.div>
  );
};

export default MotionDiv;
